// removed by extract-text-webpack-plugin
module.exports = {"stepTitle":"_-src-components-NewUserSegment-components-SegmentStep-index---stepTitle---q0kc5","resrtrictionsTitle":"_-src-components-NewUserSegment-components-SegmentStep-index---resrtrictionsTitle---1b2SG","stepBody":"_-src-components-NewUserSegment-components-SegmentStep-index---stepBody---20ftS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewUserSegment/components/SegmentStep/index.css
// module id = 827
// module chunks = 1